import { PropertiesStore } from './propertiesStore'
import { PropertyFormStore } from './singlePropertyFormStore';
import { action, makeObservable, observable } from 'mobx';
import { PROPERTY_INFORMATION_STEP } from '../../../utils/constants';

const REQUIRED_MESSAGE = 'This field is required';

const propertyInformationForm = {
  fields: {
    address: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The address is required.',
    },
    __isAddressInCorrectFormat__: {
      value: true,
      error: null,
      rule: 'accepted',
      message: 'Invalid Address Format.',
    },
    streetNumber: {
      value: '',
      error: null,
      rule: '',
    },
    streetName: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The Street Name is required.',
    },
    city: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The City is required.',
    },
    state: {
      value: '',
      error: null,
      rule: ['required', 'not_in:OR,UT,MN,ND,SD,VT'],
      customMessages: {
        required: 'This field is required',
        not_in: 'Capital provider not currently licensed in OR, UT, MN, ND, SD, or VT',
      }
    },
    county: {
      value: '',
      error: null,
      rule: '',
    },
    zipCode: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The Zip Code is required.',
    },
    latitude: {
      value: 0,
      error: null,
      rule: '',
    },
    longitude: {
      value: 0,
      error: null,
      rule: '',
    },
    aptNumber: {
      value: '',
      error: null,
      rule: '',
    },
    propertyOwnership: {
      value: false,
      error: null,
      rule: 'required',
      message: REQUIRED_MESSAGE,
    },
    propertyType: {
      value: '',
      error: null,
      rule: 'required',
      message: REQUIRED_MESSAGE,
    },
    section8: {
      value: false,
      error: null,
      rule: 'required',
      message: REQUIRED_MESSAGE,
    },
    currentlyOccupied: {
      value: false,
      error: null,
      rule: [
        {
          required_if_one_of: ['propertyOwnership', false],
        },
      ],
      message: REQUIRED_MESSAGE,
    },
    purchaseDate: {
      type: 'DATE',
      value: null,
      error: null,
      rule: [
        {
          required_if_one_of: ['propertyOwnership', true],
        },
      ],
      format: 'MM/dd/yyyy',
      message: 'Purchase Date is required.',
    },
    outstandingLoanOnTheProperty: {
      value: '',
      error: null,
      rule: [{ required_if_one_of: ['propertyOwnership', true] }],
      message: REQUIRED_MESSAGE,
    },
    payoffAmount: {
      value: '',
      error: null,
      rule: [
        {
          required_if_one_of: ['outstandingLoanOnTheProperty', true],
        },
      ],
      message: REQUIRED_MESSAGE,
    },
    cashOut: {
      value: false,
      error: null,
      rule: [
        {
          required_if_one_of: ['propertyOwnership', true],
        },
      ],
      message: REQUIRED_MESSAGE,
    },
    purchasePrice: {
      value: '',
      error: null,
      rule: 'required|min:1|max:1000000000000|not_in:0',
      message: 'Purchase price value should be greater than 0',
    },
    currentMarketValue: {
      value: '',
      error: null,
      rule: 'required|min:1|max:1000000000000|not_in:0',
      message: 'Current Market value should be greater than 0',
    },
    renoBudget: {
      value: '',
      error: null,
      rule: '',
      attribute: 'Contruction/Reno Spent to Date',
    },
    monthlyMarketRent: {
      value: '',
      error: null,
      rule: 'required|min:1|max:1000000000000|not_in:0',
      message: 'Gross Monthly Rent should be greater than 0',
      attribute: 'Monthly Market Rent',
    },
    annualHOA: {
      value: '',
      error: null,
      rule: 'required',
      attribute: 'Annual HOA',
    },
    annualTaxes: {
      value: '',
      error: null,
      rule: 'required',
      attribute: 'Annual Taxes',
    },
    annualInsurance: {
      value: '',
      error: null,
      rule: 'required',
      attribute: 'Annual Insurance',
    },
  },
  meta: {
    key: null,
    editMode: false,
    isValid: false,
    error: null,
  },
};

export class SinglePropertyPropertyStore extends PropertiesStore {
  allCounties: any;
  constructor(globalStore) {
    super(globalStore);
    makeObservable(this, {
      validatePropertyByStep: action,
      allCounties: observable
    });
  }
  createPropertyForm() {
    return new PropertyFormStore(propertyInformationForm, this.globalStore, this.loanSubType);
  }
  validatePropertyByStep(step?: number) {
    let excludedFields = [];
    if (step === PROPERTY_INFORMATION_STEP.TELL_US_ABOUT_YOUR_PROPERTY.subStep) {
      excludedFields = ['purchasePrice', 'currentMarketValue', 'monthlyMarketRent', 'annualHOA', 'annualTaxes', 'annualInsurance'];
    }
    this.propertyFormStore.validateAndCleanupProperty(excludedFields);
    const isValid = this.propertyFormStore.form.meta.isValid;
    if (!isValid) {
      this.globalStore.notificationStore.showWarningNotification({
        message: 'Please complete all the required fields for the property',
      });
      return false;
    }
    return isValid;
  }
  buildFullAddress = () => {
    const property = this.propertyFormStore.form?.fields;
    const address = property.address?.value || '';
    const city = property.city?.value || '';
    const state = property.state?.value || '';
    const zipCode = property.zipCode?.value || '';

    const fullAddress = `${address}, ${city}, ${state} ${zipCode}`.trim();

    return fullAddress;
  }
}
